export default function init() {
  document.querySelectorAll("iframe").forEach(iframe => {
    if (iframe.parentNode && iframe.parentNode.classList) {
      if (iframe.parentNode.classList.contains("video-block")) {
        iframe.onload = () => {
          setTimeout(() => {
            iframe.classList.add("loaded")
          }, 100)
        }
      } else if (iframe.parentNode.classList.contains("ss-htmleditorfield-file")) {
        iframe.parentNode.classList.add("has-iframe")
      } else if (
        iframe.closest(".typography.content-element__content") &&
        !iframe.parentNode.classList.contains("chart")
      ) {
        iframe.parentNode.classList.add("video-block")
        iframe.onload = () => {
          setTimeout(() => {
            iframe.classList.add("loaded")
          }, 100)
        }
      }
    }
  })
}
